<template>
    <div class="directSeeding">
        <div class="text1">吉林一号遥感开发者培训班线下培训直播间</div>
        <div class="tvBlock">
            <div class="tvText1">当前暂无直播内容</div>
        </div>
    </div>
</template>

<script>
import {rootUrl} from '@/globalConfig'
  //   import $ from "jquery";
  export default {
    name: "signInContent",
    data() {
      return {
          nameUser: "",
          companyUser:"",
          sexUser:"",
          sexList:["男","女"],
          ageUser:"",
          educationUser:"",
          emailUser:"",
          majorUser:"",
          educationList:["高中","专科","本科","硕士研究生","博士研究生","博士后"],
          signInPermit:false,
          isOnLine:0,
          rules: {
      notNull: (value) => {
        if (value == "" || value == null) {
          return "此项不能为空";
        } else {
          return true;
        }
      },
      emialNumber: (value) => /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value) || "邮箱不合法",
      ageJudge: (value) => {
          if(!isNaN(parseFloat(value)) && isFinite(value)){
              if(value>=0&&value<=100){
                  return true;
              }else{
                  return "年龄输入不合法";
              }
          }else{
              return "年龄输入不合法";
          }
        
      },
    },
      };
    },
    methods: {
      getKey() {
        return localStorage.getItem("token");
      },
      refreshLocation() {
        // location.reload();
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant",
        });
      },
      queryCourseRegisterStatus() {
          //判断当前状态
          this.axios
          .get("/learn_back/course/register/queryCourseRegisterStatus", { 
            headers: {
              Authorization: "Bearer " + this.getKey(),},
          })
          .then((res) => {
            console.log(res.data);
            if(this.isOnLine==1){
              let onlineStatus=res.data.data.onlineStatus
              if(this.$store.state.agentRepeat==0){
                if(onlineStatus!=2){
                  this.$router.push({path:'/signInContent',query:{'type':1}}); 
                }
              }
            }
          });
        
      },
       //带权限判断的跳转
      jumpWithPermission(type,path,fromUrl){
        //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
        //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        if(type=='可游客'){
          if(fromUrl){
            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+path,"_self")
          }
        }else if(type=='仅登录'){
          //已登录
          if(loginUserId){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }
          //未登录
          else {
            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }else if(type=='仅实名'){
          //已登录
          if(loginUserId){
            //已实名
            if(authentication=='0'){
              if(fromUrl){
                window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
              }
              else {
                window.open(rootUrl+path,"_self")
              }
            }
            //未实名
            else {
              window.open(rootUrl+'/Authentication',"_self")
            }

          }
          //未登录
          else {

            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }
      },
       //实名权限检查与处理（培训班版）
      checkAndHandleAuthentication(){
          console.log("进入实名检查")
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          console.log(loginUserId,authentication)
          console.log(localStorage.getItem('preRoute'))
          if(!loginUserId){
            this.jumpWithPermission('仅登录','/Login','/learn/signInContent')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/learn/signInContent')
        }
        return true;
      },

    },
  
    mounted() {
      if (this.checkAndHandleAuthentication()) {
        this.queryCourseRegisterStatus()
      }
    
    },
  };
</script>

<style scoped>
.directSeeding{
    position: relative;
    width: 100%;
    height: 100%;
    background: #000000;
}
.text1{
    position: absolute;
    top: 126px;
    left: calc(50% - 200px);
    width: 400px;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 20px;
    text-align: center;
}
.tvBlock{
position: absolute;
top: 246px;
left: calc(50% - 400px);
width: 800px;
height: 450px;
background: linear-gradient( 180deg, #777777 0%, #3A3A3A 100%);
}
.tvText1{
    position: absolute;
    top: 217px;
    left: 336px;
    width: 128px;
height: 16px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 16px;
color: #CCCCCC;
line-height: 16px;
text-align: right;
font-style: normal;
}
</style>